// extracted by mini-css-extract-plugin
export default {"container":"App_container__4L7Vo","appLoader":"App_appLoader__1lpmx"};